import React, { useContext, useEffect, useState } from 'react'

import { useTheme } from '@emotion/react';
import { FileOpenOutlined, FirstPage, FmdGoodTwoTone, KeyboardArrowLeft, KeyboardArrowRight, LastPage, LocationOn, MoreVertRounded, SearchOffOutlined, SearchOutlined } from '@mui/icons-material';
import { Avatar, Button, Checkbox, CircularProgress, IconButton, Input, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow } from '@mui/material';
import { Box } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AuthContext from '../../context/AuthContext';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import EditIcon from '@mui/icons-material/Edit';
import TrashIcon from '@mui/icons-material/Delete';
import LinkOffIcon from '@mui/icons-material/LinkOff';


import MapIcon from "../../assets/img/company/location_icon.png";
import CouponIcon from "../../assets/img/company/coupons_icon.png";
import ModalContext from '../../context/ModalContext';
import DrawerContext from '../../context/DrawerContext';
import DescriptionIcon from '@mui/icons-material/Description';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import { deepOrange } from '@mui/material/colors';

//components
import CustomButton from '../../common/CustomButton'
import PageSearchBar from '../../common/PageSearchBar';


export default function Categories() {

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companiesData, setCompaniesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [displayedData, setDisplayedData] = useState(categories);
  const [filterValue, setFilterValue] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [expanded, setExpanded] = React.useState(false);

  // const [anchorEl, setAnchorEl] = useState(null);

  // const open = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.target);
  // };
  

  const modalCtx = useContext(ModalContext);
  const drawerCtx = useContext(DrawerContext);
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    getAllCategories();
  }, []);

  useEffect(() => {
    if (drawerCtx.pageUpdate?.page === "categories") {
      console.log("\n\nPage update requested. Refetching all categories...");
      drawerCtx.setPageUpdate({ page: "" });
      getAllCategories();
    } else {
      console.log("No page update requests detected...");
    }
  }, [drawerCtx.pageUpdate]);

  useEffect(() => {
    if (modalCtx.pageUpdate?.page === "Categories") {
      console.log("\n\nPage update requested. Refetching all categories...");
      const categoryId = modalCtx.pageUpdate?.categoryId;
      if (categoryId) {
        console.log(`Updating category with ID: ${categoryId}`);
      }
      modalCtx.setPageUpdate({ page: "" });
      getAllCategories();
    } else {
      console.log("No page update requests detected...");
    }
  }, [modalCtx.pageUpdate]);

  useEffect(() => {
    const filteredData = categories.filter((data) => (data.title.toLowerCase().includes(searchInput.toLowerCase())));
    // Sort main categories alphabetically
    const sortedCategories = filteredData.sort((a, b) => a.title.localeCompare(b.title));
    setDisplayedData(sortedCategories);
  }, [filterValue, searchInput, loading]);

  const handleModal = (modal, data) => {
    handleClose();
    modalCtx.openModal();
    modalCtx.setDetails(modal, data);
  }

  function toggleDrawerHandler(drawer, user) {
    drawerCtx.openDrawer();
    drawerCtx.setDetails(drawer, user);
  };

  const handleClose = () => {
    setExpanded(false);
  };

  const getAllCategories = () => {    
    
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/categories`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: "Bearer " + authCtx.token }
    })
    .then(response => {
      return response.json();
    }).then(data => {
      console.log(data);
      if (data.status === 'success') {
        setCategories(data?.data || []);
        setLoading(false);
      } else {
        console.error("API Error:", data.message || "Failed to fetch categories");
        setLoading(false);
      }
    }).catch(err => {
      console.error("Error fetching categories:", err);
      setLoading(false);
    });

  }

  // Function to flatten categories array - includes both main categories and subcategories
  const getFlattenedCategories = (categories) => {
    const flattened = [];
    
    categories.forEach(category => {
      // Add main category
      flattened.push({
        id: category.id,
        title: category.title,
        type: 'main',
        parentId: null
      });
      
      // Add subcategories if they exist
      if (category.subcategories && category.subcategories.length > 0) {
        category.subcategories.forEach(subCategory => {
          flattened.push({
            id: subCategory.id,
            title: subCategory.title,
            type: 'sub',
            parentId: category.id,
            parentTitle: category.title
          });
        });
      }
    });
    
    return flattened;
  }

  // Function to check if a subcategory appears multiple times in allCategories
  const isSubcategoryDuplicated = (subCategoryId) => {
    const occurrences = getFlattenedCategories(categories).filter(cat => cat.id === subCategoryId).length;
    return occurrences > 1;
  };

  return (
    <>
      <div className="categories-container">
        <div className='header-section'>
          <span className='title'>CATEGORIES</span>
          <div className='header-items-div'>
            <PageSearchBar value={searchInput} onChange={(e) => setSearchInput(e.target.value)} placeholder="Search" />
            <CustomButton onClick={() => { toggleDrawerHandler('add-category', { type: "create", priority: 'sub', parentCategories: categories, allCategories: getFlattenedCategories(categories) }) }}>Assign / Add Category</CustomButton>
          </div>
        </div>
        <Paper sx={{ width: '100%', height: 'calc(100% - 95px)', overflow: 'hidden', overflowY: "scroll" }}>
          {
            loading ? <div className="loading"><CircularProgress size={52} style={{color: "#e84118"}} /></div> : <>
              { 
                displayedData?.map((category, index) => <Accordion key={category?.id}>
                  <AccordionSummary expanded={expanded} expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header" className='accordion-summary' TransitionComponent={Fade} TransitionProps={{ timeout: 200 }} sx={{'& .MuiAccordion-region': { height: expanded ? 'auto' : 0 }, '& .MuiAccordionDetails-root': { display: expanded ? 'block' : 'none' },}}>
                    <span className='category-title'>{category?.title}</span>
                    <div style={{flex: 1}}></div>
                    <EditIcon onClick={(e) => { e.stopPropagation(); toggleDrawerHandler("edit-category", { type: "edit", value: category, priority: "main" }); }} />
                    <TrashIcon onClick={(e) => { e.stopPropagation(); handleModal("delete-main-category", { categoryId: category.id }); }} />
                  </AccordionSummary>
                  <AccordionDetails>
                    { category.subcategories?.filter(subCategory => subCategory.relationshipType !== "mapped")
                      .sort((a, b) => a.title.localeCompare(b.title))
                      .map((subCategory, index) => 
                      <Accordion onClick={() => toggleDrawerHandler("edit-category", { type: "edit", value: { ...subCategory, mainCategory: category.title , categoryId: category.id }, priority: "sub" })} style={{ fontSize: "medium" }} expanded={false}>
                        <AccordionSummary aria-expanded="false" aria-controls="panel1-content-subcategory" id="panel1-header-items">
                          <span className='subCategory-title'>{subCategory?.title}</span>
                          <div style={{flex: 1}}></div>
                          <EditIcon onClick={(e) => { e.stopPropagation(); toggleDrawerHandler("edit-category", { type: "edit", value: { ...subCategory, mainCategory: category.title , categoryId: category.id }, priority: "sub" }); }} style={{ fontSize: "medium" }} />
                          {isSubcategoryDuplicated(subCategory.id) ? (
                            <LinkOffIcon onClick={(e) => { e.stopPropagation(); handleModal("detach-category", { categoryId: subCategory.id, parentCategoryId: category.id }); }} style={{ fontSize: "medium" }} />
                          ) : (
                            <TrashIcon onClick={(e) => { e.stopPropagation(); handleModal("delete-category", { categoryId: subCategory.id }); }} style={{ fontSize: "medium" }} />
                          )}
                        </AccordionSummary>
                      </Accordion>
                    )}
                  </AccordionDetails>
                </Accordion>
              )}
            </>
          }
        </Paper>
      </div>
    </>
  );
}
